import { IonLabel } from '@ionic/react';
import { ReactElement } from 'react';
import i18n from '../../../i18n';
import './playlist.css';
import { useIsScratchpadInPlaylist } from './scratchpad-playlist.hooks';

interface ScratchpadAlreadyInPlaylistProps {
  scratchpadId: string;
}

const ScratchpadAlreadyInPlaylist = (
  props: ScratchpadAlreadyInPlaylistProps
): ReactElement | null => {
  const { scratchpadId } = props;

  const isInPlaylist = useIsScratchpadInPlaylist(scratchpadId);

  return isInPlaylist ? (
    <IonLabel className="playlist-options-subheading">
      {i18n.t('common:scratchpad_playlist_item_in_playlist')}
    </IonLabel>
  ) : null;
};

export { ScratchpadAlreadyInPlaylist };
